<template>
  <div class="row search-wrapper">
    <div class="col-sm-10 align-content-center">
      <el-input
        :value="value"
        :placeholder="placeholder"
        clearable
        @input="$emit('input', $event)"
        @clear="handleClear"
        @keyup.enter.native="handleSearch"
      >
<!--        <i
          slot="prepend"
          class="fa fa-search"
          style="padding-left: 4px; padding-right: 4px"
        ></i>-->
      </el-input>
    </div>
    <button 
      v-if="showSearchButton" 
      class="btn btn-primary"
      @click="handleSearch"
    >
      {{ searchButtonText }}
    </button>
    <button 
      v-if="showClearButton" 
      class="btn btn-secondary"
      @click="handleClear"
    >
      {{ clearButtonText }}
    </button>
  </div>
</template>

<script>
export default {
  name: "SearchBox",
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "Search"
    },
    showSearchButton: {
      type: Boolean,
      default: true
    },
    showClearButton: {
      type: Boolean,
      default: false
    },
    searchButtonText: {
      type: String,
      default: "Search"
    },
    clearButtonText: {
      type: String,
      default: "Clear"
    }
  },
  methods: {
    handleSearch() {
      this.$emit('search', this.value);
    },
    handleClear() {
      this.$emit('input', '');
      this.$emit('clear');
    }
  }
};
</script>

<style scoped>
.search-wrapper {
  align-items: end;
}
</style>